import { render, staticRenderFns } from "./LenovoModuleSelect.vue?vue&type=template&id=4b813994&"
import script from "./LenovoModuleSelect.vue?vue&type=script&lang=js&"
export * from "./LenovoModuleSelect.vue?vue&type=script&lang=js&"
import style0 from "./LenovoModuleSelect.vue?vue&type=style&index=0&id=4b813994&prod&lang=scss&"
import style1 from "./LenovoModuleSelect.vue?vue&type=style&index=1&id=4b813994&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports